/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {overtimeReportByTimecard} from '../api'

export const useMutationOvertimeReportByTimecard = createReactQueryMutationHook('overtimeReportByTimecard', overtimeReportByTimecard)
